import ShopRegions from 'utils/shop-regions';

const regions = new ShopRegions({
  useRegionFromNavigator: true,
  setSitesFromHreflangs: true,
  redirectIfHasSelected: true,
});

regions.shouldRedirect().then((shouldRedirect) => {
  if (shouldRedirect) {
    regions.doAutomaticRedirect();
  }
});

export default regions;
